import { observer } from "mobx-react";
import { useMemo } from "react";
import { UserSettingsStore } from "./userSettingsDomain";
import { UserSettingsContainer } from "./userSettingsComponents";
import { useMessageStore, useRootStore } from "../../stores/RootStoreContext";

const UserSettingsPage = observer(() => {
  const { http, userStore, dialogStore } = useRootStore();
  const messageStore = useMessageStore();
  const settingsStore = useMemo(() => {
    {
      const store = new UserSettingsStore(userStore, messageStore, dialogStore, http);
      store.loadUserSettings();
      return store;
    }
  }, [userStore, messageStore, dialogStore, http]);
  return <UserSettingsContainer store={settingsStore} />;
});

export default UserSettingsPage;
